import * as angular from 'angular';
import { NetworkPointResource } from 'app/_resources/network-point.resource';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('NewFavoriteNetworkPointCtrl', NewFavoriteNetworkPointCtrl);

    function NewFavoriteNetworkPointCtrl(
        $rootScope,
        platformSettingsService,
        NetworkPoint: NetworkPointResource,
        networkPointSearchService,
        NETWORK_POINT_SEARCH_MODE
    ) {
        var vm = this;

        vm.NETWORK_POINT_SEARCH_MODE = NETWORK_POINT_SEARCH_MODE;
        vm.cancel = cancel;
        vm.submitNewFavoriteNetworkPoint = submitNewFavoriteNetworkPoint;

        $rootScope.$on(networkPointSearchService.BROADCAST.CANCEL, function () {
            cancel();
        });

        function cancel() {
            $rootScope.$broadcast(
                platformSettingsService.BROADCAST
                    .CANCEL_NEW_FAVORITE_NETWORK_POINT
            );
        }

        function submitNewFavoriteNetworkPoint(selectedNetworkPoints) {
            var newNetworkPointIds =
                platformSettingsService.extractIdsOfNetworkPoints(
                    selectedNetworkPoints
                );
            NetworkPoint.favorMany(
                newNetworkPointIds,
                function () {
                    $rootScope.$broadcast(
                        platformSettingsService.BROADCAST
                            .NEW_FAVORITE_NETWORK_POINT,
                        { success: true, networkPoints: selectedNetworkPoints }
                    );
                },
                function () {
                    $rootScope.$broadcast(
                        platformSettingsService.BROADCAST
                            .NEW_FAVORITE_NETWORK_POINT,
                        { success: false, networkPoints: selectedNetworkPoints }
                    );
                }
            );
        }
    }
})();
